<template>
  <div id="app" class="container-sm">
    <b-navbar toggleable="lg" type="light">
      <b-navbar-brand to="/">Sketch: Print Orders</b-navbar-brand>
      <b-navbar-toggle target="nav-collapse" />
      <b-collapse id="nav-collapse" is-nav>
        <b-navbar-nav>
          <b-nav-item
            to="/"
          >
            Submit Order
          </b-nav-item>
        </b-navbar-nav>
      </b-collapse>
    </b-navbar>
    <div class="router-view">
      <router-view />
    </div>
    <div class="footer">
      <div>
        &copy; Sketch: Art & Framing {{ year }}
      </div>
      <div class="agreement">
        By using this service you are agreeing to our
        <b-link to="/policy/terms-of-use" target="_blank">Terms of Use</b-link>.
      </div>

    </div>
  </div>
</template>

<script lang="ts">
import Vue from 'vue';
import Component from 'vue-class-component';

interface MenuItem {
  to: string;
  label: string;
}

@Component({
  components: {},
})
export default class App extends Vue {
  year: string;

  constructor() {
    super();
    this.year = new Date().getFullYear().toString();
  }
}
</script>

<style lang="scss">
@import "~bootstrap/scss/bootstrap";

a:hover {
  cursor: pointer;
  text-decoration: none;
}

.router-view {
  padding-bottom: 30px;
}

.footer {
    font-size: 80%;
}

</style>
